import { useCallback } from 'react';

import { VisitMedicalDeviceOrderCreateDraftCommand } from '@dreryk/egabinet-visit-frontend-api';

import { ModalConfirmButton } from '@dreryk/react-components';

import { useAccountAuthorizationModal } from '~libs.desktop.shared.account';

import { useVisitDocumentContext } from '../../../common/visitDocument/VisitDocumentContext';
import { medicalDevicesTranslationKeys } from '../translations';

import { useMedicalDeviceOrderPrintCommand } from './medicalDeviceOrder.hooks';
import { MedicalDeviceOrderAllFieldsFormBean, MedicalDeviceOrderFormMethods } from './medicalDeviceOrder.types';

type MedicalDeviceOrderModalPrintButtonProps = MedicalDeviceOrderFormMethods<
   MedicalDeviceOrderAllFieldsFormBean,
   'handleSubmit'
> & {
   readonly onClose?: VoidFunction;
   readonly onPrintSuccess: VoidFunction;
};

export const MedicalDeviceOrderModalPrintButton = (props: MedicalDeviceOrderModalPrintButtonProps): JSX.Element => {
   const { executeVisitDocumentCommand } = useVisitDocumentContext();
   const { openAccountAuthorizationModal, renderAccountAuthorizationnModal } = useAccountAuthorizationModal();

   const { executeAsync: printMedicalDeviceOrder } = useMedicalDeviceOrderPrintCommand({
      onSuccess: props.onPrintSuccess,
      onAuthenticationRequiredFault: openAccountAuthorizationModal,
   });
   const printMedicalDeviceOrderDocument = useCallback(
      async (formData) =>
         executeVisitDocumentCommand(VisitMedicalDeviceOrderCreateDraftCommand, async (externalId) =>
            printMedicalDeviceOrder({ data: formData, externalId: externalId })
         ),
      [executeVisitDocumentCommand, printMedicalDeviceOrder]
   );
   return (
      <>
         <ModalConfirmButton
            onClick={async () => {
               await props.handleSubmit(printMedicalDeviceOrderDocument)();
               props.onClose?.();
            }}
            label={medicalDevicesTranslationKeys.printWithoutVerification}
         />
         {renderAccountAuthorizationnModal({
            onAuthorization: props.handleSubmit(printMedicalDeviceOrderDocument),
         })}
      </>
   );
};
